module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Gersau-7d0f8719c07faf0616fc960428e8c317.svg";